<template>
  <span
    aria-label="modeling"
    :data-content="pdbInfo.modelingMsg|| 'Click to run modeling'"
    data-toggle="popover"
    data-placement="top"
    data-trigger="hover"
  >
    <span v-if="pdbInfo.modelingStatus ==='started'">
      <i class="fa fa-spinner fa-spin p-1"></i>
    </span>
    <span v-if="pdbInfo.modelingStatus ==='done'">
      <span class="text-success">
        <a :href="pdbInfo.modelUrl" target="_blank">
          <i class="fa fa-floppy-o p-1"></i>
        </a>
      </span>
    </span>
    <span v-if="pdbInfo.modelingStatus ==='error'">
      <span class="text-danger" v-on:click="modelingRequest()">
        <i class="fa fa-exclamation-circle p-1"></i>
      </span>
    </span>
    <span v-if="pdbInfo.modelingStatus ==='none'">
      <i class="fa fa-cloud-download p-1" v-on:click="modelingRequest()"></i>
    </span>
  </span>
</template>

<script>

export default {
  name: "ModelingBtn",
  props: {
    pdbInfo: Object
  },
  methods: {
    modelingRequest: function() {
      this.$dataService.modelingRequest(this.pdbInfo);
    }
  }
};
</script>

<style scoped>
</style>
